export const Config = {
  Defaults: {
    uiConfId: 46302491,
  },
  DefaultOptions: {
    uiConfId: null,
    searchApiUrl: 'https://api-prod.nvidia.com/search/graphql',
    voltronApiUrl: 'https://api-prod.nvidia.com/services/nod/api/v1/',
    site: 'https://www.nvidia.com',
    language: 'en-us',
    path: '/en-us/on-demand/search/',
    hideActions: true,
    includeRelatedVideos: true,
    onLogin: () => (window.location = '/account'),
    onLogout: () => (window.location = '/logout'),
    forChina: false,
    autoplay: false,
  },
};
